import { render } from "./ThreadBox.vue?vue&type=template&id=5af7e5d4&scoped=true"
import script from "./ThreadBox.vue?vue&type=script&lang=js"
export * from "./ThreadBox.vue?vue&type=script&lang=js"

import "./ThreadBox.vue?vue&type=style&index=0&id=5af7e5d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af7e5d4"]])

export default __exports__